<script>
export default {};
</script>

<template>
  <!--START SERVICES-->
  <section class="section pt-5" id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Nuestros Servicios</h1>
          <div class="section-title-border margin-t-20"></div>
        </div>
      </div>
      <div class="row margin-t-30">
        <div class="col-lg-6 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-bicycle text-custom"></i>
            <h4 class="padding-t-15">Motocicletas Mexicanas en USA</h4>
            <p class="padding-t-15 text-justify">Nuestros servicios abarcan una cobertura integral de responsabilidad
              civil
              dirigida específicamente a motocicletas que se encuentren temporalmente en los Estados Unidos, excluyendo su
              uso con propósitos laborales. Este innovador producto se ajusta perfectamente a los requisitos de suma
              asegurada mínima establecidos por el Estado. Es importante señalar que, si bien nuestra póliza proporciona
              una protección exhaustiva, está diseñada sin la inclusión de la cobertura de daños personales para el
              conductor y los pasajeros del vehículo asegurado. Esta medida ofrece una solución eficaz y precisa para
              quienes buscan una protección específica y cumplimiento legal para sus motocicletas durante su estancia en
              los Estados Unidos.</p>
          </div>
        </div>
        <div class="col-lg-6 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-cash text-custom"></i>
            <h4 class="padding-t-15">Coberturas Adicionales para Vehículos Comerciales</h4>
            <p class="padding-t-15 text-justify">El CAIC ofrece protección a vehículos comerciales mexicanos en diversos
              aspectos: cubre daños a la carga transportada en caso de accidente o robo (Cargo coverage), daños o robo de
              remolque no propiedad del asegurado (Trailer Interchange coverage) y responsabilidad civil general por
              incumplimiento de contrato (General Liability coverage). Los productos de CAIC son la mejor opción para
              vehículos mexicanos en Estados Unidos, con información disponible a través de representantes autorizados,
              oficinas en México y Houston, Texas. Aplican límites y condiciones sujetos a la póliza contratada, consulta
              con representante autorizado para más detalles.</p>
          </div>
        </div>
      </div>
      <div class="row margin-t-30">
        <div class="col-lg-6 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-car text-custom"></i>
            <h4 class="padding-t-15">Responsabilidad Civil para Autos MX No Residentes</h4>
            <p class="padding-t-15 text-justify">La cobertura de responsabilidad civil paga los daños como consecuencia de
              lesiones corporales y daños a la propiedad de otros por los cuales eres legalmente responsable. Si
              recibieras una demanda en tu contra como consecuencia de un accidente, esta cobertura también paga tu
              defensa. Al adquirir mayor cobertura el costo aumenta, pero potencialmente te da más protección en caso de
              un accidente. Mientras más alto sea tu límite de cobertura, mayor protección te daremos.</p>
          </div>
        </div>
        <div class="col-lg-6 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-like2 text-custom"></i>
            <h4 class="padding-t-15">Responsabilidad Civil para Camiones MX No Residentes</h4>
            <p class="padding-t-15 text-justify">Ofrecemos seguros de responsabilidad civil para camiones mexicanos en los
              Estados Unidos, cumpliendo con requisitos del DOT. Cubrimos distintos niveles de RC, desde mercancía general
              hasta carga peligrosa, en colaboración con el DOT. Brindamos coberturas adicionales como gastos médicos y
              protección de carga. Nuestra póliza tiene sólido respaldo financiero y registro NAIC #10904. Para la mejor
              cobertura en vehículos mexicanos en EE. UU., confía en CAIC a través de representantes y oficinas en México
              y Houston. Se aplican límites y condiciones.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--START SERVICES-->
</template>